import SearchIndexPage from "@/pages/SearchIndexPage";
import publicPath from "@/utils/publicPath";
import { NextPage } from "next";
import { NextSeo } from "next-seo";

const Page: NextPage = () => (
  <>
    <NextSeo title="検索結果" canonical={publicPath("/search")} />
    <SearchIndexPage />;
  </>
);
export default Page;
